module.exports = __webpack_public_path__ + "img/00634453000412.d25fe53d.png";